import React, { useRef, useState, } from "react";
import useNavModel, { RouterParamType } from "@/model/navModel";
import {TopButs} from "./TopButs"
import {FormBox} from "./FormBox"
import {TableBox} from "./TableBox"

export const OutputDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    return (
        <>
            <TopButs {...detailsInfo}/>
            <FormBox {...detailsInfo}/>
            <TableBox {...detailsInfo}/>
        </>
    )
}